module.exports = __webpack_public_path__ + "img/home_1.f713c5a0.png";